import React, { useState, useEffect, startTransition } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';


export const ContactdetailsPanel = () => {
  const [ContactDetail, setContactDetail] = useState([]);

  useEffect(() => {
  const fetchData = async () => {
    const response = await axios.get(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_contact_info"
    );
    setContactDetail(response.data.data);
  };
  fetchData();
}, []);

// const deleteUser = async (userId) => {
//   try {
//     const formData = new FormData();
//     formData.append("id", userId);

//     const response = await axios.post(
//       "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_contact_info",
//       formData
//     );

//     console.log("Delete API response:", response.data);

//     if (response.data.status === true) {
//       setAddress((prevData) =>
//         prevData.filter((item) => item.id !== userId)
//       );
//       toast.error(response.data.message || "Data Deleted Successfully!");
//     } else {
//       toast.error(response.data.error || "Delete failed.");
//     }
//   } catch (error) {
//     console.error("There was an error!", error);
//   }
// };



  return (
    <div className="container-fluid" style={{ width:"80%", marginTop:"100px", marginLeft:"250px"}}>
      <h4 className="mb-4 fw-semibold">Contact Details</h4>

      {ContactDetail.map((Data, index) => (
        <div key={index} className="border rounded p-4 mb-4 shadow-sm bg-light">
          <div className="d-flex justify-content-end">
            <Link to={`/contact-detail/${Data.id}`}>
              <button className="btn btn-primary btn-sm me-2">
                <i className="fa-regular fa-pen-to-square text-white"></i> Edit
              </button>
            </Link>
          </div>
          <p><strong>Description:</strong> {Data.description}</p>
          <p><strong>Phone:</strong> {Data.phone}</p>
          <p><strong>E-mail:</strong> {Data.phone}</p>  
          <p><strong>Address:</strong> {Data.address}</p>
        </div>
      ))}
    </div>
  );
};

export const EditContactDetails = () => {
  const [ContactDetailsUser, setContactDetailsUser] = useState({
    description: "",
    phone: "",
    phone: "",
    address: "",
  });

  const { id } = useParams();
  const navigate = useNavigate();

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setContactDetailsUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const ContactDetailData = async () => {
      try {
        const response = await axios.post(
          `https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_by_id_contact_info`,
          {
            id: id,
          }
        );
        setContactDetailsUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    ContactDetailData();
  }, [id]);

const submitForm = async (e) => {
  e.preventDefault();

  const payload = {
    id: id,
    description: ContactDetailsUser.description || "",
    phone: ContactDetailsUser.phone || "",
    address: ContactDetailsUser.address || "",
  };

  // 🔍 Debug log
  console.log("Submitting JSON:", payload);

  try {
    const response = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_contact_info",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Update response:", response.data);

    if (response.data.status === true) {
      toast.success(response.data.message || "Data updated successfully");
      navigate("/contact-detail");
    } else {
      toast.error(response.data.message || "Failed to update Contact Details");
    }
  } catch (error) {
    console.error("There was an error!", error);
    toast.error("Something went wrong while updating!");
  }
};

  return (
    <div className="page-content">
          {/* Start Container Fluid */}
          <div className="container-fluid">
            {/* ========== Page Title Start ========== */}
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <h4 className="mb-0 fw-semibold">Contact Edit</h4>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="javascript: void(0);">Contact</a>
                    </li>
                    <li className="breadcrumb-item active">Contact Edit</li>
                  </ol>
                </div>
              </div>
            </div>
            {/* ========== Page Title End ========== */}
            <div className="row">
              <div className="col-xl-9 col-lg-8 ">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">General Information</h4>
                  </div>
                  <div className="card-body">
                    <form onSubmit={submitForm}>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label htmlFor="Contact_name" className="form-label">
                              Contact Description
                            </label>
                            <input
                              type="text"
                              id="description"
                              className="form-control"
                              placeholder="Enter Title"
                              name="description"
                              value={ContactDetailsUser.description}
                              onChange={changeHandler}
                              required
                            />
                          </div>
                        </div>
    
                        <div className="col-lg-6 mb-3">
                          <label htmlFor="manuf_state" className="form-label text-dark">
                            Contact Phone
                          </label>
                          <input
                            type="text"
                            id="phone"
                            name='phone'
                            value={ContactDetailsUser.phone}
                            onChange={changeHandler}
                            className="form-control"
                            placeholder="Enter Phone Number"
                          />
                        </div>
    
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label htmlFor="manuf_name" className="form-label">
                              Contact E-mail
                            </label>
                            <input
                              type="text"
                              id="email"
                              className="form-control"
                              placeholder="Enter E-mail"
                              name="email"
                              value={ContactDetailsUser.email}
                              onChange={changeHandler}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label htmlFor="manuf_name" className="form-label">
                              Contact Address
                            </label>
                            <input
                              type="text"
                              id="address"
                              className="form-control"
                              placeholder="Enter Address"
                              name="manuf_name"
                              value={ContactDetailsUser.address}
                              onChange={changeHandler}
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="p-3 bg-light mb-3 rounded">
                        <div className="row justify-content-end g-2">
                          <div className="col-lg-2">
                            <button
                              type="submit"
                              className="btn btn-outline-secondary w-100"
                            >
                              Save Change
                            </button>
                          </div>
                          <div className="col-lg-2">
                            <Link
                              to="/Contact-list"
                              className="btn btn-primary w-100"
                            >
                              Cancel
                            </Link>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Container Fluid */}
          {/* ========== Footer Start ========== */}
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 text-center">
                  © Venton. Crafted by{" "}
                  <iconify-icon
                    icon="iconamoon:heart-duotone"
                    className="fs-18 align-middle text-danger"
                  />{" "}
                  <a href className="fw-bold footer-text" target="_blank">
                    Techzaa
                  </a>
                </div>
              </div>
            </div>
          </footer>
          {/* ========== Footer End ========== */}
        </div>
  );
};

